<template>
  <div class="supplier-mgmt">
    <el-menu :default-active="activeIndex" mode="horizontal" style="display: none">
      <el-menu-item
        v-for="item in componentsList"
        :key="item.id"
        :index="item.id"
        @click="
          () => {
            setComponents(item);
          }
        "
      >
        {{ item.text }}
      </el-menu-item>
    </el-menu>
    <transition name="router-slid" mode="out-in">
      <keep-alive>
        <component :is="currentComponent"></component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import SupplierView from "./children/SupplierView";
import MaterialView from "./children/MaterialView";
export default {
  data() {
    return {
      componentsList: [
        {
          id: "1",
          text: "供应商视图",
          name: "supplierView",
        },
        {
          id: "2",
          text: "材料视图",
          name: "materialView",
        },
      ],
      currentComponent: "supplierView",
      activeIndex: "1",
    };
  },
  activated() {},
  components: {
    SupplierView,
    MaterialView,
  },
  methods: {
    setComponents(item) {
      this.activeIndex = item.id;
      this.currentComponent = item.name;
    },
  },
};
</script>

<style lang="scss">
.supplier-mgmt {
  height: calc(100vh - 64px);
  overflow: hidden;
}
</style>
